import http from '@/utils/http';
import i18n from '@/main';

const URL_BASE = '/segmentos';

export default {
    buscarSegmentos() {
        return http.get({
            url: URL_BASE + `/buscar`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoSegmentos')
        });
    },

    findAllByFiltro({ page, size, order, filtro, lockScreen = true }) {
        return http.get({
            url:
                URL_BASE +
                `/filtrar/?page=${page}&size=${size}${order}&filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSegmentos')
        });
    },

    cadastrarSegmento(body) {
        return http.post({
            url: `${URL_BASE}`,
            data: body,
            lockScreen: true
        });
    }
};
